import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import theme from '../styles/theme';
import policyData from '../data/policy';
import media from '../styles/media';
import Button from '../components/Button';

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.label = 'Back';
  }
  render() {
    return (
      <Wrapper>
        <Container>
          <h2>Privacy Policy</h2>
          <p>
            Trellis Properties and each of our affiliates and partnerships is
            committed to maintaining the accuracy, confidentiality and security
            of your personal information. This Privacy Policy describes the
            personal information that Trellis Properties collects from or about
            you, how we use that information, and to whom we disclose that
            information.
          </p>
          <h5>Collecting Personal Information</h5>
          <p>
            Trellis Properties collects personal information to better serve
            your needs, whether purchasing products and services from us or
            obtaining service or warranty work. In order to provide you with our
            wide variety of services, products and promotions, we may collect
            the following information:
          </p>
          <ListContainer>
            {policyData[0].list.map((data, index) => {
              return (
                <ul key={index}>
                  <li>{data}</li>
                </ul>
              );
            })}
          </ListContainer>
          <h5>Personal Information Security</h5>
          <p>
            Like you, Trellis Properties values our personal information. Part
            of valuing your personal information is making sure that it is
            protected and kept confidential. We achieve this by:
          </p>
          <ListContainer>
            {policyData[1].list.map((data, index) => {
              return (
                <ul key={index}>
                  <li>{data}</li>
                </ul>
              );
            })}
          </ListContainer>
          <h5>Personal Information Updating</h5>
          <p>
            Trellis Properties wants to ensure that your personal information is
            always correct up to date. If your personal information changes or
            is incorrect, updates can be made by contacting your representative
            with the change and any other information you feel is necessary.
          </p>
          <p>
            We will keep your information as long as is necessary to continue to
            meet your customer needs and any legal requirements we may have.
            However, once your personal information no longer needed, we will
            destroy it.
          </p>
          <h5>Personal Data</h5>
          {policyData[2].list.map((data, index) => {
            return <p key={index}>{data}</p>;
          })}
          <Contact>
            <h5>Trellis Properties</h5>
            <a href="mailto:info@trellisproperties.ca">
              <p>info@trellisproperties.ca</p>
            </a>
            <br />
            <br />
          </Contact>
          <Link to="/">
            <Button label={this.label} />
          </Link>
        </Container>
      </Wrapper>
    );
  }
}

export default PrivacyPolicy;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Contact = styled.div`
  width: 170px;
  p:nth-child(4) {
    margin-bottom: 20px !important;
  }
  p {
    margin-bottom: 0px !important;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 645px;
  height: 378px;
  position: relative;
  top: 50%;
  transform: translateY(15%);
  @media (max-width: ${media.sm}) {
    width: 80%;
  }
  h2 {
    margin-bottom: 50px;
  }

  p {
    margin-bottom: 40px;
  }
  h5 {
    text-align: left;
    letter-spacing: 0px;
    margin-bottom: 20px;
    color: #f57f29;
    font-family: 'korolev';
    font-style: normal;
    font-weight: 300;
    text-transform: uppercase;
  }
  ul {
    padding-left: 20px;
  }
  li {
    font-size: 16px;
    list-style-position: outside;
    letter-spacing: 0;
    line-height: 32px;
    font-family: 'Source Sans Pro Light';
    line-height: 27px;
  }
  button {
    color: #f57f29;
    margin-bottom: 100px;
  }
`;

const ListContainer = styled.div`
  margin-bottom: 30px;
`;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy.js